import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "markdown-page-wrapper pa-8" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, {
      fluid: "",
      class: "mx-auto markdown-content"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref: "markdownContainer",
          innerHTML: _ctx.renderedMarkdown
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    })
  ]))
}